<template>
<v-container fluid grid-list-md>
  <v-text-field
		:value="display"
		prefix="$"
		readonly
		height="24"
	>
	</v-text-field>
  <!-- <span class="reference-prefix">$<input class="reference-value" type="text" :value="display" readonly  /></span> -->
</v-container>
</template>

<script>
import Vue from 'vue';
import { answerService } from '../../services/answerService';

export default {
  name: 'ReferenceCell',
  props: {
    id: String,
    field: String,
    reference: Object
  },
  data: () => ({
    theValue: null
  }),
  mounted () {
    // const val = (this.theValue) ? this.theValue.value : 0;
    // this.$set(this.theValue, 'strValue', '0');
    // let me = this;
    // var ans = me.answer;
    // if (ans && this.id) {
    //   var val = ans[this.id];
    //   var value = val[0][this.field] ? val[0][this.field] : 0;
    // 	this.theValue = value;
    // 	console.log(this.theValue);
    // } else {
    //   this.theValue = answerService.getAnswerValue(null);
    // }
  },
  created () {
    // const me = this;
    // this.$store.subscribe((mutation, state) => {
    //   if (mutation.type.startsWith('save') && me.id === mutation.payload.id) {
    //     const value = mutation.payload.value;
    //     const val = value ? value[this.field] : 0;
    //     this.theValue = answerService.getAnswerValue(val);
    //   }
    // });
  },
  computed: {
    answer: function () {
      return this.$store.getters['answersArray'];
    },
    display: function () {
      // This variable is used for holding the numerical version of the displayed value
			var sum = 0;
			let me = this;

			if (this.id && this.field) {
				sum = me.answer[this.id][0][this.field];
			} else if (this.reference.ops.length === 0) {
				sum = me.answer[this.reference.cells[0].qId][
					this.reference.cells[0].index
				][this.reference.cells[0].name];
			} else {
				for (var i = 0; i < this.reference.cells.length; i++) {
					sum +=
						me.answer[this.reference.cells[i].qId][this.reference.cells[i].index][
						this.reference.cells[i].name
						];
				}
			}

			this.theValue = (sum != null)
      ? answerService.getAnswerValue(sum)
      : answerService.getAnswerValue(null);

      return !this.theValue ? '' : this.theValue.strValue;
    }
  }
};
</script>
<style scoped>
.v-text-field >>> input {
  text-align: right;
  padding: 3px;
}
.reference-prefix {
  text-align: right;
  font-weight: bold;
  font-size: 12pt;
}
.reference-value {
  text-align: right;
  font-weight: bold;
  font-size: 12pt;
  width: 130px;
  padding-right: 3px;
  border: 0px solid;
  border-radius: 4px;
}

/* span.textbox {
	    background-color: #FFF;
	    color: #888;
	    line-height:20px;
	    height:20px;
	    padding:3px;
	    border:1px #888 solid;
	    font-size:9pt;
}

span.textbox input {
      border: 0px;
	    background-color: #FFF;
  } */
</style>
